export default {"src":"/_next/static/media/logo-black.8c76d0c9.svg","height":64,"width":100,"blurWidth":0,"blurHeight":0};